export const SOLIDJS_IMPORT_YAML = `project:
  name: recipe-solidjs
  tags:
    - zerops-recipe

services:
  - hostname: ssrapp
    type: nodejs@20
    zeropsSetup: app
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-solidjs-nodejs

  - hostname: staticapp
    type: static
    zeropsSetup: app
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-solidjs-static`;
